import { LeadPageContext } from "@/modules/lead-page/context/lead-page.context";
import React, { useContext, useState } from "react";

const useEditBestTimeToCall = () => {
  const { lead } = useContext(LeadPageContext);
  const [editBestTimeToCallModalOpen, setEditBestTimeToCallModalOpen] =
    useState(false);
  const [bestTimeToCall, setBestTimeToCall] = useState<string>("");

  const handleChangeBestTimeToCall = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setBestTimeToCall(e.target.value);
  };
  return {
    bestTimeToCall: {
      editBestTimeToCallModalOpen,
      setEditBestTimeToCallModalOpen,
      handleChangeBestTimeToCall,
      value: lead?.data?.lead?.best_time_to_call || "Not Set",
      state: bestTimeToCall,
    },
  };
};

export default useEditBestTimeToCall;
